import { render, staticRenderFns } from "./file.vue?vue&type=template&id=acfabe04&"
import script from "./file.vue?vue&type=script&lang=js&"
export * from "./file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports